/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as CompaniesRouteImport } from './routes/companies'
import { Route as LayoutRouteImport } from './routes/_layout'
import { Route as IndexRouteImport } from './routes/index'
import { Route as Error503RouteImport } from './routes/error/503'
import { Route as Error500RouteImport } from './routes/error/500'
import { Route as Error404RouteImport } from './routes/error/404'
import { Route as Error401RouteImport } from './routes/error/401'
import { Route as LayoutSlugSettingsRouteImport } from './routes/_layout/$slug/settings'
import { Route as LayoutSlugProfileRouteImport } from './routes/_layout/$slug/profile'
import { Route as LayoutSlugLibraryRouteImport } from './routes/_layout/$slug/library'
import { Route as LayoutSlugCsrPlanRouteImport } from './routes/_layout/$slug/csr-plan'
import { Route as LayoutSlugActionsRouteImport } from './routes/_layout/$slug/actions'
import { Route as LayoutSlugAccessManagementRouteImport } from './routes/_layout/$slug/access-management'
import { Route as LayoutSlugIndicatorsIndexRouteImport } from './routes/_layout/$slug/indicators/index'
import { Route as LayoutSlugDashboardIndexRouteImport } from './routes/_layout/$slug/dashboard/index'
import { Route as LayoutSlugIndicatorsPerYearRouteImport } from './routes/_layout/$slug/indicators/per-year'
import { Route as LayoutSlugIndicatorsCollecteIndexRouteImport } from './routes/_layout/$slug/indicators/collecte/index'
import { Route as LayoutSlugIndicatorsCollecteYearIndexRouteImport } from './routes/_layout/$slug/indicators/collecte/$year/index'
import { Route as LayoutSlugIndicatorsCollecteYearManageRouteImport } from './routes/_layout/$slug/indicators/collecte/$year/manage'

const CompaniesRoute = CompaniesRouteImport.update({
  id: '/companies',
  path: '/companies',
  getParentRoute: () => rootRouteImport,
} as any)
const LayoutRoute = LayoutRouteImport.update({
  id: '/_layout',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const Error503Route = Error503RouteImport.update({
  id: '/error/503',
  path: '/error/503',
  getParentRoute: () => rootRouteImport,
} as any)
const Error500Route = Error500RouteImport.update({
  id: '/error/500',
  path: '/error/500',
  getParentRoute: () => rootRouteImport,
} as any)
const Error404Route = Error404RouteImport.update({
  id: '/error/404',
  path: '/error/404',
  getParentRoute: () => rootRouteImport,
} as any)
const Error401Route = Error401RouteImport.update({
  id: '/error/401',
  path: '/error/401',
  getParentRoute: () => rootRouteImport,
} as any)
const LayoutSlugSettingsRoute = LayoutSlugSettingsRouteImport.update({
  id: '/$slug/settings',
  path: '/$slug/settings',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutSlugProfileRoute = LayoutSlugProfileRouteImport.update({
  id: '/$slug/profile',
  path: '/$slug/profile',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutSlugLibraryRoute = LayoutSlugLibraryRouteImport.update({
  id: '/$slug/library',
  path: '/$slug/library',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutSlugCsrPlanRoute = LayoutSlugCsrPlanRouteImport.update({
  id: '/$slug/csr-plan',
  path: '/$slug/csr-plan',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutSlugActionsRoute = LayoutSlugActionsRouteImport.update({
  id: '/$slug/actions',
  path: '/$slug/actions',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutSlugAccessManagementRoute =
  LayoutSlugAccessManagementRouteImport.update({
    id: '/$slug/access-management',
    path: '/$slug/access-management',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutSlugIndicatorsIndexRoute =
  LayoutSlugIndicatorsIndexRouteImport.update({
    id: '/$slug/indicators/',
    path: '/$slug/indicators/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutSlugDashboardIndexRoute =
  LayoutSlugDashboardIndexRouteImport.update({
    id: '/$slug/dashboard/',
    path: '/$slug/dashboard/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutSlugIndicatorsPerYearRoute =
  LayoutSlugIndicatorsPerYearRouteImport.update({
    id: '/$slug/indicators/per-year',
    path: '/$slug/indicators/per-year',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutSlugIndicatorsCollecteIndexRoute =
  LayoutSlugIndicatorsCollecteIndexRouteImport.update({
    id: '/$slug/indicators/collecte/',
    path: '/$slug/indicators/collecte/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutSlugIndicatorsCollecteYearIndexRoute =
  LayoutSlugIndicatorsCollecteYearIndexRouteImport.update({
    id: '/$slug/indicators/collecte/$year/',
    path: '/$slug/indicators/collecte/$year/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutSlugIndicatorsCollecteYearManageRoute =
  LayoutSlugIndicatorsCollecteYearManageRouteImport.update({
    id: '/$slug/indicators/collecte/$year/manage',
    path: '/$slug/indicators/collecte/$year/manage',
    getParentRoute: () => LayoutRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/companies': typeof CompaniesRoute
  '/error/401': typeof Error401Route
  '/error/404': typeof Error404Route
  '/error/500': typeof Error500Route
  '/error/503': typeof Error503Route
  '/$slug/access-management': typeof LayoutSlugAccessManagementRoute
  '/$slug/actions': typeof LayoutSlugActionsRoute
  '/$slug/csr-plan': typeof LayoutSlugCsrPlanRoute
  '/$slug/library': typeof LayoutSlugLibraryRoute
  '/$slug/profile': typeof LayoutSlugProfileRoute
  '/$slug/settings': typeof LayoutSlugSettingsRoute
  '/$slug/indicators/per-year': typeof LayoutSlugIndicatorsPerYearRoute
  '/$slug/dashboard': typeof LayoutSlugDashboardIndexRoute
  '/$slug/indicators': typeof LayoutSlugIndicatorsIndexRoute
  '/$slug/indicators/collecte': typeof LayoutSlugIndicatorsCollecteIndexRoute
  '/$slug/indicators/collecte/$year/manage': typeof LayoutSlugIndicatorsCollecteYearManageRoute
  '/$slug/indicators/collecte/$year': typeof LayoutSlugIndicatorsCollecteYearIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/companies': typeof CompaniesRoute
  '/error/401': typeof Error401Route
  '/error/404': typeof Error404Route
  '/error/500': typeof Error500Route
  '/error/503': typeof Error503Route
  '/$slug/access-management': typeof LayoutSlugAccessManagementRoute
  '/$slug/actions': typeof LayoutSlugActionsRoute
  '/$slug/csr-plan': typeof LayoutSlugCsrPlanRoute
  '/$slug/library': typeof LayoutSlugLibraryRoute
  '/$slug/profile': typeof LayoutSlugProfileRoute
  '/$slug/settings': typeof LayoutSlugSettingsRoute
  '/$slug/indicators/per-year': typeof LayoutSlugIndicatorsPerYearRoute
  '/$slug/dashboard': typeof LayoutSlugDashboardIndexRoute
  '/$slug/indicators': typeof LayoutSlugIndicatorsIndexRoute
  '/$slug/indicators/collecte': typeof LayoutSlugIndicatorsCollecteIndexRoute
  '/$slug/indicators/collecte/$year/manage': typeof LayoutSlugIndicatorsCollecteYearManageRoute
  '/$slug/indicators/collecte/$year': typeof LayoutSlugIndicatorsCollecteYearIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_layout': typeof LayoutRouteWithChildren
  '/companies': typeof CompaniesRoute
  '/error/401': typeof Error401Route
  '/error/404': typeof Error404Route
  '/error/500': typeof Error500Route
  '/error/503': typeof Error503Route
  '/_layout/$slug/access-management': typeof LayoutSlugAccessManagementRoute
  '/_layout/$slug/actions': typeof LayoutSlugActionsRoute
  '/_layout/$slug/csr-plan': typeof LayoutSlugCsrPlanRoute
  '/_layout/$slug/library': typeof LayoutSlugLibraryRoute
  '/_layout/$slug/profile': typeof LayoutSlugProfileRoute
  '/_layout/$slug/settings': typeof LayoutSlugSettingsRoute
  '/_layout/$slug/indicators/per-year': typeof LayoutSlugIndicatorsPerYearRoute
  '/_layout/$slug/dashboard/': typeof LayoutSlugDashboardIndexRoute
  '/_layout/$slug/indicators/': typeof LayoutSlugIndicatorsIndexRoute
  '/_layout/$slug/indicators/collecte/': typeof LayoutSlugIndicatorsCollecteIndexRoute
  '/_layout/$slug/indicators/collecte/$year/manage': typeof LayoutSlugIndicatorsCollecteYearManageRoute
  '/_layout/$slug/indicators/collecte/$year/': typeof LayoutSlugIndicatorsCollecteYearIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/companies'
    | '/error/401'
    | '/error/404'
    | '/error/500'
    | '/error/503'
    | '/$slug/access-management'
    | '/$slug/actions'
    | '/$slug/csr-plan'
    | '/$slug/library'
    | '/$slug/profile'
    | '/$slug/settings'
    | '/$slug/indicators/per-year'
    | '/$slug/dashboard'
    | '/$slug/indicators'
    | '/$slug/indicators/collecte'
    | '/$slug/indicators/collecte/$year/manage'
    | '/$slug/indicators/collecte/$year'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/companies'
    | '/error/401'
    | '/error/404'
    | '/error/500'
    | '/error/503'
    | '/$slug/access-management'
    | '/$slug/actions'
    | '/$slug/csr-plan'
    | '/$slug/library'
    | '/$slug/profile'
    | '/$slug/settings'
    | '/$slug/indicators/per-year'
    | '/$slug/dashboard'
    | '/$slug/indicators'
    | '/$slug/indicators/collecte'
    | '/$slug/indicators/collecte/$year/manage'
    | '/$slug/indicators/collecte/$year'
  id:
    | '__root__'
    | '/'
    | '/_layout'
    | '/companies'
    | '/error/401'
    | '/error/404'
    | '/error/500'
    | '/error/503'
    | '/_layout/$slug/access-management'
    | '/_layout/$slug/actions'
    | '/_layout/$slug/csr-plan'
    | '/_layout/$slug/library'
    | '/_layout/$slug/profile'
    | '/_layout/$slug/settings'
    | '/_layout/$slug/indicators/per-year'
    | '/_layout/$slug/dashboard/'
    | '/_layout/$slug/indicators/'
    | '/_layout/$slug/indicators/collecte/'
    | '/_layout/$slug/indicators/collecte/$year/manage'
    | '/_layout/$slug/indicators/collecte/$year/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LayoutRoute: typeof LayoutRouteWithChildren
  CompaniesRoute: typeof CompaniesRoute
  Error401Route: typeof Error401Route
  Error404Route: typeof Error404Route
  Error500Route: typeof Error500Route
  Error503Route: typeof Error503Route
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/companies': {
      id: '/companies'
      path: '/companies'
      fullPath: '/companies'
      preLoaderRoute: typeof CompaniesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_layout': {
      id: '/_layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof LayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/error/503': {
      id: '/error/503'
      path: '/error/503'
      fullPath: '/error/503'
      preLoaderRoute: typeof Error503RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/error/500': {
      id: '/error/500'
      path: '/error/500'
      fullPath: '/error/500'
      preLoaderRoute: typeof Error500RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/error/404': {
      id: '/error/404'
      path: '/error/404'
      fullPath: '/error/404'
      preLoaderRoute: typeof Error404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/error/401': {
      id: '/error/401'
      path: '/error/401'
      fullPath: '/error/401'
      preLoaderRoute: typeof Error401RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_layout/$slug/settings': {
      id: '/_layout/$slug/settings'
      path: '/$slug/settings'
      fullPath: '/$slug/settings'
      preLoaderRoute: typeof LayoutSlugSettingsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/$slug/profile': {
      id: '/_layout/$slug/profile'
      path: '/$slug/profile'
      fullPath: '/$slug/profile'
      preLoaderRoute: typeof LayoutSlugProfileRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/$slug/library': {
      id: '/_layout/$slug/library'
      path: '/$slug/library'
      fullPath: '/$slug/library'
      preLoaderRoute: typeof LayoutSlugLibraryRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/$slug/csr-plan': {
      id: '/_layout/$slug/csr-plan'
      path: '/$slug/csr-plan'
      fullPath: '/$slug/csr-plan'
      preLoaderRoute: typeof LayoutSlugCsrPlanRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/$slug/actions': {
      id: '/_layout/$slug/actions'
      path: '/$slug/actions'
      fullPath: '/$slug/actions'
      preLoaderRoute: typeof LayoutSlugActionsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/$slug/access-management': {
      id: '/_layout/$slug/access-management'
      path: '/$slug/access-management'
      fullPath: '/$slug/access-management'
      preLoaderRoute: typeof LayoutSlugAccessManagementRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/$slug/indicators/': {
      id: '/_layout/$slug/indicators/'
      path: '/$slug/indicators'
      fullPath: '/$slug/indicators'
      preLoaderRoute: typeof LayoutSlugIndicatorsIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/$slug/dashboard/': {
      id: '/_layout/$slug/dashboard/'
      path: '/$slug/dashboard'
      fullPath: '/$slug/dashboard'
      preLoaderRoute: typeof LayoutSlugDashboardIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/$slug/indicators/per-year': {
      id: '/_layout/$slug/indicators/per-year'
      path: '/$slug/indicators/per-year'
      fullPath: '/$slug/indicators/per-year'
      preLoaderRoute: typeof LayoutSlugIndicatorsPerYearRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/$slug/indicators/collecte/': {
      id: '/_layout/$slug/indicators/collecte/'
      path: '/$slug/indicators/collecte'
      fullPath: '/$slug/indicators/collecte'
      preLoaderRoute: typeof LayoutSlugIndicatorsCollecteIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/$slug/indicators/collecte/$year/': {
      id: '/_layout/$slug/indicators/collecte/$year/'
      path: '/$slug/indicators/collecte/$year'
      fullPath: '/$slug/indicators/collecte/$year'
      preLoaderRoute: typeof LayoutSlugIndicatorsCollecteYearIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/$slug/indicators/collecte/$year/manage': {
      id: '/_layout/$slug/indicators/collecte/$year/manage'
      path: '/$slug/indicators/collecte/$year/manage'
      fullPath: '/$slug/indicators/collecte/$year/manage'
      preLoaderRoute: typeof LayoutSlugIndicatorsCollecteYearManageRouteImport
      parentRoute: typeof LayoutRoute
    }
  }
}

interface LayoutRouteChildren {
  LayoutSlugAccessManagementRoute: typeof LayoutSlugAccessManagementRoute
  LayoutSlugActionsRoute: typeof LayoutSlugActionsRoute
  LayoutSlugCsrPlanRoute: typeof LayoutSlugCsrPlanRoute
  LayoutSlugLibraryRoute: typeof LayoutSlugLibraryRoute
  LayoutSlugProfileRoute: typeof LayoutSlugProfileRoute
  LayoutSlugSettingsRoute: typeof LayoutSlugSettingsRoute
  LayoutSlugIndicatorsPerYearRoute: typeof LayoutSlugIndicatorsPerYearRoute
  LayoutSlugDashboardIndexRoute: typeof LayoutSlugDashboardIndexRoute
  LayoutSlugIndicatorsIndexRoute: typeof LayoutSlugIndicatorsIndexRoute
  LayoutSlugIndicatorsCollecteIndexRoute: typeof LayoutSlugIndicatorsCollecteIndexRoute
  LayoutSlugIndicatorsCollecteYearManageRoute: typeof LayoutSlugIndicatorsCollecteYearManageRoute
  LayoutSlugIndicatorsCollecteYearIndexRoute: typeof LayoutSlugIndicatorsCollecteYearIndexRoute
}

const LayoutRouteChildren: LayoutRouteChildren = {
  LayoutSlugAccessManagementRoute: LayoutSlugAccessManagementRoute,
  LayoutSlugActionsRoute: LayoutSlugActionsRoute,
  LayoutSlugCsrPlanRoute: LayoutSlugCsrPlanRoute,
  LayoutSlugLibraryRoute: LayoutSlugLibraryRoute,
  LayoutSlugProfileRoute: LayoutSlugProfileRoute,
  LayoutSlugSettingsRoute: LayoutSlugSettingsRoute,
  LayoutSlugIndicatorsPerYearRoute: LayoutSlugIndicatorsPerYearRoute,
  LayoutSlugDashboardIndexRoute: LayoutSlugDashboardIndexRoute,
  LayoutSlugIndicatorsIndexRoute: LayoutSlugIndicatorsIndexRoute,
  LayoutSlugIndicatorsCollecteIndexRoute:
    LayoutSlugIndicatorsCollecteIndexRoute,
  LayoutSlugIndicatorsCollecteYearManageRoute:
    LayoutSlugIndicatorsCollecteYearManageRoute,
  LayoutSlugIndicatorsCollecteYearIndexRoute:
    LayoutSlugIndicatorsCollecteYearIndexRoute,
}

const LayoutRouteWithChildren =
  LayoutRoute._addFileChildren(LayoutRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LayoutRoute: LayoutRouteWithChildren,
  CompaniesRoute: CompaniesRoute,
  Error401Route: Error401Route,
  Error404Route: Error404Route,
  Error500Route: Error500Route,
  Error503Route: Error503Route,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
